@if (configurationResource.isLoading()) {
    <mat-spinner mode="indeterminate" diameter="30" class="mx-a my-15"></mat-spinner>
} @else {
    <form [formGroup]="form" autocomplete="off">
        <div class="field-row">
            <div class="field-row-title">
                Import enabled
            </div>
            <div class="field-row-element">
                <app-row-with-toggle formControlName="enabled">
                </app-row-with-toggle>
            </div>
        </div>
    </form>

}
